/**
*	Please note this object relies on momentJS to generate the dates
*/
var validityPasser = {};
(function(){
	validityPasser.getValidToDateFromDate = function(validityPeriod, fromDate, validFromTime){
		// get the earliest time
		var startTime = moment(validFromTime, 'h:mm');
		var startDate = moment(fromDate);
		startTime.date(startDate.date());
		startTime.month(startDate.month());
		startTime.year(startDate.year());
		// on the earliest date
		var myDur = moment.duration(validityPeriod);
		// set the date to the earliest possible date / time
		toDate = startTime;
		// add milliseconds basedon the validity period to get the last possible time
		toDate.milliseconds(myDur.as('milliseconds'));
		return toDate;
	};
	// validity time
	validityPasser.isAfterValidFromTime = function(validFromTime, timeToCheck){
		var startTime = moment(validFromTime,'h:mm');
		timeToCheck = moment(timeToCheck);
		// set date
		startTime.date(timeToCheck.date());
		startTime.month(timeToCheck.month());
		startTime.year(timeToCheck.year());
		// compare the dates
		if(timeToCheck.isBefore(startTime)){
			return false;
		}
		return true;
	};
	validityPasser.isBeforeValidFromTimeMax = function(validFromTimeMax, timeToCheck){
		var startTime = moment(validFromTimeMax, 'h:mm');
		timeToCheck = moment(timeToCheck);
		// set date
		startTime.date(timeToCheck.date());
		startTime.month(timeToCheck.month());
		startTime.year(timeToCheck.year());
		// compare the dates
		if(timeToCheck.isAfter(startTime)){
			return false;
		}
		return true;
	};

	validityPasser.checkDateIsInRange = function(validityPeriod, fromDate, timeToCheck, validFromTime){
		var calculatedFinalDate = validityPasser.getValidToDateFromDate(validityPeriod, fromDate, validFromTime);
		timeToCheck = moment(timeToCheck);
		fromDate = moment(fromDate);
		if(timeToCheck.isBefore(calculatedFinalDate) && timeToCheck.isAfter(fromDate)){
			return true;
		} else {
			return false;
		}
	};
	validityPasser.checkDateIsAfterRange = function(validityPeriod, fromDate, timeToCheck, validFromTime){
		var calculatedFinalDate = validityPasser.getValidToDateFromDate(validityPeriod, fromDate, validFromTime);
		timeToCheck = moment(timeToCheck);
		if(timeToCheck.isAfter(calculatedFinalDate)){
			return true;
		} else {
			return false;
		}
	};
	validityPasser.checkDateIsBeforeRange = function(fromDate, timeToCheck){
		fromDate = moment(fromDate);
		timeToCheck = moment(timeToCheck);
		if(timeToCheck.isBefore(fromDate)){
			return true;
		} else {
			return false;
		}
	};
	validityPasser.checkDateIsToday = function(timeToCheck){
		var today = moment().hour(0).minute(0).second(0).milliseconds(0);
		timeToCheck = moment(timeToCheck).hour(0).minute(0).second(0).milliseconds(0);
		var daysDiff = moment.duration(today.diff(timeToCheck)).days();
		if(daysDiff > 0 || daysDiff < 0){
			return false
		} else {
			return true;
		}
	}

	validityPasser.getNextValidFromDateAndTime = function(validityPeriod, validFromDate, validFromTime, validFromTimeMax, timeToCheck){
		var initialValidFrom = validFromDate;
		var updatedValidFrom = false;
		// check for null or undefined validFromDate - setup validFromDate to be same date as date checking
		if(typeof validFromDate === 'undefined' || !validFromDate){
			validFromDate = moment(timeToCheck);
			validFromDate.hour(0);
			validFromDate.minute(0);
			validFromDate.second(0);
			validFromDate.milliseconds(0);
			updatedValidFrom = true;
		}

		var nextValidDetails = {
			minTime: moment(validFromTime, 'HH:mm:ss').format('HH:mm'),
			minDate: moment(validFromDate, 'YYYY-MM-DD'),
			maxTime: moment(validFromTimeMax, 'HH:mm:ss').format('HH:mm'),
			maxDate: validityPasser.getValidToDateFromDate(validityPeriod, validFromDate, validFromTime)
		};

		// If there a validity period with a valid from date then return
		if(validityPeriod && validFromDate) {
			return nextValidDetails
		}
		// if the date is today
		if((validityPasser.checkDateIsToday(timeToCheck)|| updatedValidFrom) && validityPasser.checkDateIsInRange(validityPeriod, validFromDate, timeToCheck, validFromTime)){ // booking is for today
			// check that the current time is valid
			if(validityPasser.isAfterValidFromTime(validFromTime, timeToCheck)){
				if(validityPasser.isBeforeValidFromTimeMax(validFromTimeMax, timeToCheck)){
					// current time is the min
					nextValidDetails.minDate = moment(timeToCheck);
					nextValidDetails.minTime = moment(timeToCheck).format('HH:mm');
				} else {
					// set the min time for this value
					minTime = moment(validFromTime, 'h:mm');
					// tomorrow at the minimum time is the min
					nextValidDetails.minDate = moment(timeToCheck).add(1,'days').hour(minTime.hour()).minute(minTime.minute()).second(minTime.second());
					nextValidDetails.minTime = validFromTime;
					if(!validityPasser.checkDateIsInRange(validityPeriod, validFromDate, nextValidDetails.minDate, validFromTime)){
						return null; // date is on the last date of the range but the time is out of the min and max
					}
				}
			} else {
				// min is min
				nextValidDetails.minDate = moment(timeToCheck);
				nextValidDetails.minTime = validFromTime;
			}
		} else if (validityPasser.checkDateIsBeforeRange(validFromDate, timeToCheck)){ // booking is in future
			// min is the valid from date at the valid form time
			nextValidDetails.minDate = moment(validFromDate);
			nextValidDetails.minTime = validFromTime;
		} else { // cannot be booked because the booking has passed.
			return null;
		}
		if(typeof initialValidFrom === 'undefined'){
			nextValidDetails.maxDate = null;
		}
		return nextValidDetails;
	};
	// used for working with a minutes handle that decides when the next available from time slot is to start the licence from
	validityPasser.getValidFromTimes = function(validityPeriod, validFromDate, validFromTime, validFromTimeMax, timeToCheck, minutes){
		var nextValidFrom = validityPasser.getNextValidFromDateAndTime(validityPeriod, validFromDate, validFromTime, validFromTimeMax, timeToCheck);
		var validFromTimes = {times:[],startCurrentTime:''};
		var isToday = false;
		// start with the minimum date time:
		var tmpStartTime = moment(nextValidFrom.minTime,'hh:mm');
		var tmpEndTime = moment(nextValidFrom.maxTime,'hh:mm');
		var startCurrTime = moment(nextValidFrom.minDate);
		// check if date being checked is today
		if(startCurrTime.diff(moment().hour(0).minute(0).second(0).milliseconds(0),'hours') < 24){
			isToday = true;
		}
		tmpRange = moment.range(tmpStartTime,tmpEndTime);
		tmpRange.by('minutes',function(mom){
			if(mom.minute() % minutes === 0){
				if(isToday){
					if(mom.isAfter(moment())){
						validFromTimes.times.push(mom.format('HH:mm'));
					} // else the check if for today but the time is before this
				} else {
					validFromTimes.times.push(mom.format('HH:mm'));
				}
				if(validFromTimes.startCurrentTime.length === 0 && mom.isAfter(startCurrTime)){
					validFromTimes.startCurrentTime = mom.format('HH:mm');
				}
			}
		});
		validFromTimes.startCurrentTime = validFromTimes.times[0];
		return validFromTimes;
	};
})();
